var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "el-card",
    [
      _c("h3", [_vm._v("INFORMACIÓN DE LA FACTURA")]),
      _c("Core-DataSection", { attrs: { elements: _vm.elements } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }